module.exports = __webpack_public_path__ + "media/xunwei.19f8727c.mp4";